/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Office */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { createNestablePublicClientApplication } from '@azure/msal-browser';
import TaskpaneComponent from './TaskpaneComponent';

// Global variable to store the MSAL instance
let pca: any = undefined;

// Make pca globally accessible
(window as any).pca = pca;

Office.onReady(async (info) => {
  if (info.host === Office.HostType.Outlook) {
    // Hide the sideload message and show the app body
    const sideloadMsg = document.getElementById('sideload-msg');
    const appBody = document.getElementById('app-body');
    
    if (sideloadMsg) {
      sideloadMsg.style.display = 'none';
    }
    if (appBody) {
      appBody.style.display = 'flex';
    }

    // Initialize the public client application for NAA
    try {
      const clientId = process.env.AZURE_CLIENT_ID || 'Enter_the_Application_Id_Here';
      const tenantId = process.env.AZURE_TENANT_ID;
      
      // Use common authority for multi-tenant support, or specific tenant if provided
      const authority = tenantId 
        ? `https://login.microsoftonline.com/${tenantId}`
        : 'https://login.microsoftonline.com/common';

      pca = await createNestablePublicClientApplication({
        auth: {
          clientId: clientId,
          authority: authority,
        },
      });
      
      // Update the global reference
      (window as any).pca = pca;
    } catch (error) {
      console.error('Failed to initialize MSAL:', error);
    }

    // Render the React component
    const container = document.getElementById('app-body');
    if (container) {
      const root = createRoot(container);
      root.render(<TaskpaneComponent />);
    }
  }
});
